<template>
  <div class="ms-form">
    <q-form @submit="onSubmit">
      <section class="ms-form-section">
        <h3 class="ms-form-section__title"><i class="fa-solid fa-building" aria-hidden="true" />Основное</h3>
        <div class="ms-form-grid">
          <CustomInput label="Название" :required="true" :value="form.cleaning_name" @change_input="(v) => onChange('cleaning_name', v)" />
          <CustomInput label="Юридическое наименование" :value="form.legal_name" @change_input="(v) => onChange('legal_name', v)" />
          <CustomInput label="ФИО директора" :value="form.director_fio" @change_input="(v) => onChange('director_fio', v)" />
          <CustomInput label="БИН" :value="form.bin" @change_input="(v) => onChange('bin', v)" />
          <CustomSelect
            label="Город"
            :required="true"
            :options="cities"
            option-value-key="city_id"
            option-label-key="city_name"
            :value="form.city_id"
            @change="(v) => onChange('city_id', v)"
          />
          <CustomSelect
            label="Тип контрагента"
            :options="contragentTypes"
            option-value-key="contragent_type_id"
            option-label-key="contragent_type_name"
            :value="form.contragent_type_id"
            clearable
            @change="(v) => onChange('contragent_type_id', v)"
          />
          <CustomInput class="ms-form-wide" label="Адрес" :value="form.address" @change_input="(v) => onChange('address', v)" />
        </div>
      </section>

      <section class="ms-form-section">
        <h3 class="ms-form-section__title"><i class="fa-solid fa-address-card" aria-hidden="true" />Контакты и банк</h3>
        <div class="ms-form-grid">
          <CustomInput label="Телефон" :value="form.phone" @change_input="(v) => onChange('phone', v)" />
          <CustomInput label="Email" :value="form.email" @change_input="(v) => onChange('email', v)" />
          <CustomInput label="БИК" :value="form.bik" @change_input="(v) => onChange('bik', v)" />
          <CustomInput label="ИИК" :value="form.iik" @change_input="(v) => onChange('iik', v)" />
          <CustomInput label="КБЕ" :value="form.kbe" @change_input="(v) => onChange('kbe', v)" />
          <CustomInput label="ГУИД" :value="form.guid" @change_input="(v) => onChange('guid', v)" />
          <CustomInput class="ms-form-wide" label="Наименование банка" :value="form.bank_name" @change_input="(v) => onChange('bank_name', v)" />
          <CustomInput class="ms-form-wide" label="Текст для договора" type="textarea" :value="form.contract_text" @change_input="(v) => onChange('contract_text', v)" />
        </div>
      </section>
      <CustomModalFooter :btn-loading="loading" />
    </q-form>
  </div>
</template>

<script>
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import { handbookContractorsAPI } from "@/views/handbook/contractors/api";

const field = (body, key) => body?.[key] ?? "";

export default {
  name: "AddHandbookCleaning",
  components: { CustomModalFooter, CustomInput, CustomSelect },
  props: ["data"],
  data() {
    const body = this.data?.body;
    return {
      loading: false,
      cities: [],
      contragentTypes: [],
      form: {
        cleaning_id: body?.cleaning_id || 0,
        cleaning_name: field(body, "cleaning_name"),
        legal_name: field(body, "legal_name"),
        director_fio: field(body, "director_fio"),
        bin: field(body, "bin"),
        city_id: body?.city_id || null,
        contragent_type_id: body?.contragent_type_id || null,
        address: field(body, "address"),
        phone: field(body, "phone"),
        email: field(body, "email"),
        bik: field(body, "bik"),
        iik: field(body, "iik"),
        kbe: field(body, "kbe"),
        guid: field(body, "guid"),
        bank_name: field(body, "bank_name"),
        contract_text: field(body, "contract_text"),
      },
    };
  },
  mounted() {
    this.loadOptions();
  },
  methods: {
    onChange(key, value) {
      this.form[key] = value;
    },
    async loadOptions() {
      const [cities, types] = await Promise.all([
        handbookContractorsAPI.getCity(),
        handbookContractorsAPI.getContragentType(),
      ]);
      this.cities = cities?.data || [];
      this.contragentTypes = types?.data || [];
    },
    async onSubmit() {
      this.loading = true;
      await this.data?.onSubmit(this.form);
      this.loading = false;
    },
  },
};
</script>
